import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { InputCollectionType } from '../schema/types';
import { UserCalendarUrl } from '../../UserDashboardUrl';

const getInputCollection = () =>
  apiClient
    .get<InputCollectionType[]>(expand(UserCalendarUrl.INPUT_COLLECTION), {})
    .then((response) => response.data);

export const useListInputCollectionQuery = createApiQueryHook(
  ['input-collection'],
  getInputCollection,
);
